export const MOBILITY_CONSTANTS = {
  MANUAL_DELIVERY_ACCEPTED_FILE_TYPES: ['image/jpeg', 'image/jpg', 'image/png'],
  DESTINATION_MODEL_DESC: 'Destino',
  ORIGIN_MODEL_DESC: 'Origen'
};
